import React, { useEffect, useState } from 'react';
import bearerimg from '../images/bearerimg.jpg';
import { IoArrowUpCircleOutline } from "react-icons/io5";
import { Player, Controls } from '@lottiefiles/react-lottie-player';

export default function ExecutiveMember() {

  const lottiee = require('../images/lottiee.json');
  const loading = require('../images/loading.json');

    const ofcBearer = [
        {
            name: "name??",
            img: bearerimg
        },
    ]

    const [membrData, setmembrData] = useState([]);
    const [loader, setloader] = useState(false)

    const exeData = ()=>{
      setloader(true)
      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };
      
      fetch("https://api.padampura.com/Committee_MemberList", requestOptions)
       .then((response) => response.json())
        .then((result) => {
          if(result.status === true){
            // console.log(result)
            setmembrData(result.data.ExecutiveMembers);
            setloader(false)
          }
        })
        .catch((error) => console.error(error))
        .finally(()=> setloader(false))
    }

    const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth" 
        });
      };

      useEffect(()=>{
        exeData();
        scrollToTop();
      },[])

  return (
    <div className='mt-5 p-5'>
        <div className='container'>
          <div className='text-center' style={{ color: "#000", fontFamily: "Poppins", fontWeight: 500, fontSize: 24 }}>EXECUTIVE MEMBERS</div>
          <div className='row mt-5'>
           {
            loader?(
              <>
                <div className='text-center' style={{ fontFamily:"Poppins", fontSize:16 }} >Loading...</div>
                     <Player
                         autoplay
                         loop
                         src={loading}
                         style={{ height: '200px', width: '200px' }}
                     >
                     <Controls visible={false} buttons={['play', 'repeat', ]} />
                 </Player>
              </>
            ):membrData?.length == 0?(
              <>
                <Player
                       autoplay
                       loop
                       src={lottiee}
                       style={{ height: '180px', width: '180px' }}
                   >
                   <Controls visible={false} buttons={['play', 'repeat', ]} />
               </Player>
              <div className='text-center' style={{ fontFamily:"Poppins", fontSize:16, color:'red' }} >Data Not Present...</div>
              </>
            ):(
              membrData?.map((item)=>{
                return(
                 <div className='col-lg-2 col-md-6 col-sm-12 mb-4'>
                    <div className='card border-1 rounded-0'>
                        {/* <img src={item.img} style={{width:"100%"}} /> */}
                        <div className='text-center p-3' style={{ fontFamily:'Poppins', fontWeight:400, color:"#808B96", fontSize:14 }} >{item.ExecutiveMembers_Name}</div>
                    </div>
                 </div>
                )
              })
            )
           }
          </div>
        </div>
        <button className="scroll-to-top-button border-0 rounded-2" onClick={scrollToTop} style={{ width:40,height:40, backgroundColor:"red", color:"#fff", alignItems:"center", justifyContent:"center", display:"flex" }}><IoArrowUpCircleOutline style={{ fontSize:40 }} /></button>
    </div>
  )
}
